import { Grid2, Typography } from "@mui/material";
import BankMobileViewStyles from "./BankMobileView.module.css";
import axisbank from "../../../ui-utils/photos/axis2.svg";
import hdfcbank from "../../../ui-utils/photos/hdfcmob.png";
import icicibank from "../../../ui-utils/latestPics/icici.svg";
import en from "../../../i18n/English/Aboutus/research.json";
import hi from "../../../i18n/Hindi/Aboutus/research.json";
import kn from "../../../i18n/Kannada/Aboutus/research.json";
import ma from "../../../i18n/Marathi/Aboutus/research.json";
import gu from "../../../i18n/Gujarati/Aboutus/research.json";
import { useLanguage } from "../../../Context/LangContext";
export default function MobileView() {
  const { language } = useLanguage();
  const translations = { en, hi, kn, gu, ma };
  const t = translations[language] || translations.en;
  return (
    <>
      <Grid2 className={BankMobileViewStyles.bank_main}>
        <div className={BankMobileViewStyles.title_card}>
          <Typography className={BankMobileViewStyles.bank_title}>
            {t.bank}
          </Typography>
        </div>

        <Grid2 className={BankMobileViewStyles.inner_card}>
          <Grid2 className={BankMobileViewStyles.bank_card1}>
            <div className={BankMobileViewStyles.img_div1}>
              {/* <Typography className={BankMobileViewStyles.bankname}>
                Axis Bank
              </Typography> */}
              <img
                src={axisbank}
                className={BankMobileViewStyles.bank_img1}
                alt="bank"
              ></img>
            </div>
          </Grid2>

            <Grid2 className={BankMobileViewStyles.bank_card2}>
              {/* <Typography className={BankMobileViewStyles.bankname}>
                HDFC Bank
              </Typography> */}
              <div className={BankMobileViewStyles.img_div2}>
                <img
                  src={hdfcbank}
                  className={BankMobileViewStyles.bank_img2}
                  alt="bank"
                ></img>
              </div>
            </Grid2>

           <Grid2 className={BankMobileViewStyles.bank_card3}>
            {/* <Typography className={BankMobileViewStyles.bankname}>
              ICICI Bank
            </Typography> */}
            <div className={BankMobileViewStyles.img_div2}>
              <img
                src={icicibank}
                className={BankMobileViewStyles.bank_img2}
                alt="bank"
              ></img>
            </div>
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  );
}
